import { gql } from '@apollo/client';
import {
  ANALYTICS_METRICS_ATTRIBUTES,
  ANALYTICS_PAGE_BASE_DATA,
  EDIT_EXPERIMENT_ATTRIBUTES,
  EDIT_EXPERIMENT_VARIANT_ATTRIBUTES,
  EXPERIMENT_ATTRIBUTES,
  EXPERIMENT_VARIANT_ATTRIBUTES,
} from 'api/fragments';

/**
 * Index Page
 */

export const fetchConversionsByEventNamesQuery = gql`
  query conversionsByEventNames {
    conversionsByEventNames {
      eventName
      conversions {
        id
      }
    }
  }
`;

export const fetchExperimentTypes = gql`
  query getExperimentTypes($campaignId: Long!) {
    getExperimentTypes(campaignId: $campaignId) {
      ... on ExperimentTypesSuccess {
        allowedTypes
      }
      ... on ExperimentTypesFailure {
        message
      }
    }
  }
`;

export const fetchExperimentsTableDataQuery = gql`
  query fetchExperiments(
    $filterInfo: ExperimentFilterInfoInput
    $pagination: Pagination
    $sort: ExperimentSortDefinitionInput
    $search: String
  ) {
    experiments(filterInfo: $filterInfo, pagination: $pagination, sort: $sort, search: $search) {
      info {
        count
        offset
        limit
        page
      }
      results {
        ... on Experiment {
          ...experimentAttributes
          variations {
            ... on ExperimentVariation {
              ...experimentVariantAttributes
            }
          }
        }
      }
    }
  }
  ${EXPERIMENT_ATTRIBUTES}
  ${EXPERIMENT_VARIANT_ATTRIBUTES}
`;

/**
 * Monitor Page
 */
export const fetchExperimentAnalyticsBasePageQuery = gql`
  query fetchExperiment($id: Long!) {
    experiment(id: $id) {
      ... on Experiment {
        ...analyticsPageBaseDataAttributes
      }
    }
  }
  ${ANALYTICS_PAGE_BASE_DATA}
`;

export const fetchExperimentAnalyticsOverviewTabQuery = gql`
  query fetchExperiment($id: Long!) {
    experiment(id: $id) {
      ... on Experiment {
        holdout {
          ... on GroupPercentHoldoutDefinition {
            holdoutUserCount
            experimentWinningCriteria
          }
        }
        variations {
          ... on ExperimentVariation {
            id
            experimentSends
            experimentWinningCriteria
          }
        }
      }
    }
  }
`;

export const fetchExperimentAnalyticsPerformanceTabQuery = gql`
  query fetchExperiment($id: Long!, $startTime: Instant, $endTime: Instant) {
    experiment(id: $id) {
      ... on Experiment {
        holdout {
          ... on GroupPercentHoldoutDefinition {
            holdoutUserCount
            experimentWinningCriteria
            metrics(startTime: $startTime, endTime: $endTime) {
              ...variantMetricsAndHoldoutAttributes
            }
          }
        }
        variations {
          ... on ExperimentVariation {
            id
            metrics(startTime: $startTime, endTime: $endTime) {
              ...variantMetricsAndHoldoutAttributes
            }
          }
        }
      }
    }
  }
  ${ANALYTICS_METRICS_ATTRIBUTES}
`;

/**
 * Takeover
 */

export const fetchExperimentEditQuery = gql`
  query fetchExperiment($id: Long!, $locale: String) {
    experiment(id: $id) {
      ... on Experiment {
        ...editExperimentAttributes
      }
    }
  }
  ${EDIT_EXPERIMENT_ATTRIBUTES}
`;

export const fetchExperimentEditVariantQuery = gql`
  query fetchExperimentEditVariant($id: Long!, $locale: String) {
    experiment(id: $id) {
      variations {
        ... on ExperimentVariation {
          ...editExperimentVariantAttributes
        }
      }
    }
  }
  ${EDIT_EXPERIMENT_VARIANT_ATTRIBUTES}
`;

export const fetchDynamicSenderProjectSetting = gql`
  query getCurrentProject {
    currentProject {
      useDynamicSenders
    }
  }
`;

export const fetchCampaignSchedulerMsgParams = gql`
  query getCampaignSchedulerMsgParams($id: Long!) {
    campaign: campaign(id: $id) {
      schedulerMsgParams {
        scheduleType
      }
    }
  }
`;
